import { APIQuery } from "./api.base";
import { APIResponse } from "../types/api.types";

export const getById = async (id: number): Promise<APIResponse> => {
    return await APIQuery(`/association/get/${id}`, 'POST', []);
};

export const list = async (): Promise<APIResponse> => {
    return await APIQuery("/association/list", "GET", []);
};

export const detail = async (associationId: number): Promise<APIResponse> => {
    return await APIQuery("/association/detail", "GET", [], { association_id: associationId });
};

export const create = async (payload: { name: string }): Promise<APIResponse> => {
    return await APIQuery("/association/create", "POST", [], payload);
};

export const update = async (payload: { association_id: number, name: string }): Promise<APIResponse> => {
    return await APIQuery("/association/update", "PUT", [], payload);
};

export const addMember = async (payload: { association_id: number, user_id: number, role: string }): Promise<APIResponse> => {
    return await APIQuery("/association/member/add", "POST", [], payload);
};

export const removeMember = async (payload: { association_id: number, user_id: number }): Promise<APIResponse> => {
    return await APIQuery("/association/member/remove", "POST", [], payload);
};

export const updateMemberRole = async (payload: { association_id: number, user_id: number, role: string }): Promise<APIResponse> => {
    return await APIQuery("/association/member/role-update", "PUT", [], payload);
};
